import React from 'react';
import logo from './dog.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1> Best Detective Friends</h1>
      </header>
    </div>
  );
}

export default App;
